import React, {Component} from 'react';
import {DocType, getDocTypeLangKey} from "../definitions/DocType";
import {
  emptyICountSsqDataByDocType,
  emptyTechnicalGetSsqDataByPageRequest,
  ICountOfEachDocTypeRequest,
  ICountsOfEachDocType,
  IGetSsqDataByPageRequest,
  ISsqDataDocument,
  SsqDataRepository
} from "../repositories/SsqDataRepository";
import {CategoryRepository} from "../repositories/category/CategoryRepository";
import {LanguageService} from "../language/LanguageService";
import CategoryStore from "../repositories/category/CategoryStore";
import {ErrorpageWrap, TechnicalDocumentListArea, ViewmoreArea} from "../style/CommonStyledComponents";
import {ISrchParam, SsqDataColumnTitles, SubTabButtons, SubTabTableArea, SwiperArrow} from "./ProductPage";
import {Swiper, SwiperSlide} from "swiper/react";
import SwiperCore, {Navigation} from "swiper";
import 'swiper/swiper.min.css';
import {BlogContainer} from "communitypage/blog/BlogPage";
import BlogDocumentListItem from "communitypage/blog/BlogDocumentListItem";
import svcs from "services";
import {i18ns} from "language/i18nkey";
import {PERIOD_TYPE, SORT_TYPE} from "communitypage/common/CommunityFilter";
import {connect} from "react-redux";
import {IfLoginInfo} from "models/IfLoginInfo";
import {isEqual} from "lodash-es";
import {SsqImages} from "images/SsqImages";
import {IfDocCommentInfo} from "models/IfSsqDataDocCommentEntity";
import {Accordion} from "react-accessible-accordion";
import SsqDocumentsAccordionItem from "productpage/SsqDocumentsAccordionItem";
import ToastPopup from "productpage/ToastPopup";
import {AccordionWrapper} from './ProductDownloadTabPanel';
import {ProductTablePadding} from "productpage/ProductDownloadTabPanel";
import clsx from "clsx";

interface Props {
  selectedCategoryId: number;
  languageService: LanguageService;
  categoryRepository: CategoryRepository;
  ssqDataRepository: SsqDataRepository;
  categoryStore: CategoryStore;
  getTranslation: Function;
  srchParam: ISrchParam;
  loginInfo: IfLoginInfo;
  preSortType?: string;
  resetFilter?: Function;
  displayLoginPopup: Function;
  commentList: Array<IfDocCommentInfo>;
  loadAllCategories: () => void;
}


interface State {
  selectedDocType: string;
  ssqDataDocuments: ISsqDataDocument[];
  ssqDataVersion: string;
  ssqDataDocumentsCounts: ICountsOfEachDocType;
  pageNum: number;
  isMobile: boolean;
  isMounted: boolean;
  toastType: string;
  seq: number;
  previousClickedDocumentId: number;
}

class ProductTechnicalTabPanel extends Component<Props, State> {
  private readonly NO_DATA = "NO_DATA";
  private readonly PAGE_NUM_UNIT = 20;

  constructor(props: Props) {
    super(props);

    this.state = {
      selectedDocType: DocType.TECHNICAL_GUIDE,
      ssqDataDocuments: [],
      ssqDataVersion: "",
      ssqDataDocumentsCounts: emptyICountSsqDataByDocType,
      pageNum: 0,
      isMobile: false,
      isMounted: false,
      seq: 0,
      toastType: '',
      previousClickedDocumentId: 0,
    };
  }

  async componentDidMount() {
    const {selectedCategoryId} = this.props;
    await this.getSsqDataDocuments(Number(selectedCategoryId));
    await this.getSsqDataDocumentsCounts(Number(selectedCategoryId));

    this.setState({pageNum: 0});
    if (window.innerWidth < 1199)
      this.setState({isMobile: true});
    else
      this.setState({isMobile: false});

    this.setState({
      isMounted: true,
    });
  }

  async componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    const selectedCategoryId = this.props.selectedCategoryId;

    if ((prevProps.selectedCategoryId !== selectedCategoryId) || !isEqual(prevProps.srchParam, this.props.srchParam)) {
      await this.setState({pageNum: 0});
      await this.getSsqDataDocuments(Number(selectedCategoryId));
      await this.getSsqDataDocumentsCounts(Number(selectedCategoryId));
    }

    if (prevState.selectedDocType != this.state.selectedDocType) {
      await this.getSsqDataDocuments(Number(selectedCategoryId));
      this.setState({pageNum: 0});
    }

    if (prevState.pageNum != this.state.pageNum && this.state.pageNum !== 0) {
      await this.getSsqDataDocuments(Number(selectedCategoryId), true);
    }

    if (prevProps.preSortType !== this.props.preSortType) {
      await this.setState({pageNum: 0});
      await this.getSsqDataDocuments(Number(selectedCategoryId));
    }
  }

  getDefaultSelectedTab(docCounts: ICountsOfEachDocType): string {
    return this.state.selectedDocType;

    if (docCounts.technicalGuideCount > 0)
      return DocType.TECHNICAL_GUIDE;
    else if (docCounts.applicationNoteCount > 0)
      return DocType.APPLICATION_NOTE;
    else if (docCounts.troubleShootingCount > 0)
      return DocType.TROUBLE_SHOOTING;
    //else return this.NO_DATA;
  }

  async getSsqDataDocuments(categoryId: number, pageChanged: boolean = false) {

    if (this.state.selectedDocType !== this.NO_DATA) {
      let getSsqDataByPageRequest: IGetSsqDataByPageRequest = {
        ...emptyTechnicalGetSsqDataByPageRequest,
        pageNum: this.state.pageNum,
        categoryId: categoryId,
        docTypes: [this.state.selectedDocType],
        exposeSiteLanguage: this.props.languageService.getLanguage(),
        sortType: this.props.srchParam.sortType === SORT_TYPE.RECENT ? 0 : this.props.srchParam.sortType === SORT_TYPE.UPDATE ? 1 : 2,
        periodType: this.props.srchParam.periodType === PERIOD_TYPE.DEFAULT ? 0 :
          this.props.srchParam.periodType === PERIOD_TYPE.WEEK ? 1 :
            this.props.srchParam.periodType === PERIOD_TYPE.ONEMONTH ? 2 :
              this.props.srchParam.periodType === PERIOD_TYPE.SIXMONTH ? 3 : 4,
        tagType: this.props.srchParam.tagType,
        keyword: this.props.srchParam.keyword,
        userId: this.props.loginInfo.userId
      };

      let ssqDataDocuments = await this.props.ssqDataRepository.getSsqDataByPage(getSsqDataByPageRequest);

      if (this.state.pageNum > 0 && pageChanged) {
        this.setState({ssqDataDocuments: [...this.state.ssqDataDocuments, ...ssqDataDocuments]});
      } else {
        this.setState({ssqDataDocuments});
      }
    } else {
      this.setState({ssqDataDocuments: []});
    }
  }

  async getSsqDataDocumentsCounts(categoryId: number) {
    let countOfEachDocTypeRequest: ICountOfEachDocTypeRequest = {
      ...emptyTechnicalGetSsqDataByPageRequest,
      categoryId: categoryId,
      exposeSiteLanguage: this.props.languageService.getLanguage(),
      sortType: this.props.srchParam.sortType === SORT_TYPE.RECENT ? 0 : this.props.srchParam.sortType === SORT_TYPE.UPDATE ? 1 : 2,
      periodType: this.props.srchParam.periodType === PERIOD_TYPE.DEFAULT ? 0 :
        this.props.srchParam.periodType === PERIOD_TYPE.WEEK ? 1 :
          this.props.srchParam.periodType === PERIOD_TYPE.ONEMONTH ? 2 :
            this.props.srchParam.periodType === PERIOD_TYPE.SIXMONTH ? 3 : 4,
      tagType: this.props.srchParam.tagType,
      keyword: this.props.srchParam.keyword,
      userId: this.props.loginInfo.userId
    };

    let ssqDataDocumentsCounts =
      await this.props.ssqDataRepository.getCountsOfEachDocType(countOfEachDocTypeRequest);

    this.setState({
      selectedDocType: this.getDefaultSelectedTab(ssqDataDocumentsCounts),
      ssqDataDocumentsCounts
    });
  }


  isMoreDocumentsOnNextPage(documentCount: number) {
    return documentCount > this.PAGE_NUM_UNIT * (this.state.pageNum + 1);
  }

  isRenderTechnicalDocumentViewMore(docType: string) {
    if (docType === DocType.APPLICATION_NOTE)
      return this.isMoreDocumentsOnNextPage(this.state.ssqDataDocumentsCounts.applicationNoteCount);
    else if (docType === DocType.TECHNICAL_GUIDE)
      return this.isMoreDocumentsOnNextPage(this.state.ssqDataDocumentsCounts.technicalGuideCount);
    else if (docType === DocType.TROUBLE_SHOOTING)
      return this.isMoreDocumentsOnNextPage(this.state.ssqDataDocumentsCounts.troubleShootingCount);
  }


  countDocTypeWithSsqDataDocumentAll(docType: string): number | undefined {
    if (docType === DocType.APPLICATION_NOTE)
      return this.state.ssqDataDocumentsCounts.applicationNoteCount;
    else if (docType === DocType.TECHNICAL_GUIDE)
      return this.state.ssqDataDocumentsCounts.technicalGuideCount;
    else if (docType === DocType.TROUBLE_SHOOTING)
      return this.state.ssqDataDocumentsCounts.troubleShootingCount;
    else
      return 0;
  }

  getPageCount() {
    return this.PAGE_NUM_UNIT * (this.state.pageNum + 1);
  }

  getTotalCount() {
    return this.countDocTypeWithSsqDataDocumentAll(this.state.selectedDocType);
  }

  clickedTag(tag) {
    console.log(tag);
  }

  docListItemTrans(key: string): string {
    svcs.svcLang.setNamespace(i18ns.cmmnty);
    return svcs.svcLang.getTranslationByKey(key) || "";
  }

  renderNoDocumentPageReset() {
    return <ErrorpageWrap className={"ErrorpageWrap"}>
      <div className={"Errorpage"}>
        <img alt={"empty_search_result.svg"} src={SsqImages.common.icon.emptySearchResult()}/>
        <p className={"error-tit"}>{this.props.getTranslation("I18N_NO_DOCUMENT")}</p>
        <p className={"error-txt"}>{this.props.getTranslation("I18N_NO_DOCUMENT_NOTICE")}</p>
        {
          !isEqual(this.props.srchParam, {
            sortType: '',
            periodType: '',
            tagType: [],
            categoryId: 0,
            keyword: '',
          }) &&
          <button className="error-button" onClick={() => this.props.resetFilter()}>
            {this.props.getTranslation("I18N_NO_DOCUMENT_RESET")}
          </button>
        }
      </div>
    </ErrorpageWrap>;
  }

  renderNoDocumentPage() {
    return <ErrorpageWrap className={"ErrorpageWrap"}>
      <div className={"Errorpage-product"}>
        <img alt={"empty_search_result.svg"} src={SsqImages.common.icon.emptySearchResult()}/>
        <p className={"error-tit"}>{this.props.getTranslation("I18N_NO_DOCUMENT")}</p>
        <p className={"error-txt"}>{this.props.getTranslation("I18N_NO_DOCUMENT_NOTICE")}</p>
      </div>
    </ErrorpageWrap>;
  }


  selectDocTypeCountNoDocumentPage() {
    if ((this.countDocTypeWithSsqDataDocumentAll(this.state.selectedDocType) === 0 && this.getTabCnt() !== 0 ||
      this.countDocTypeWithSsqDataDocumentAll(this.state.selectedDocType) === 0) && this.props.srchParam.keyword !== "")
      return this.renderNoDocumentPageReset();

    if (this.props.srchParam.keyword == "" && (this.countDocTypeWithSsqDataDocumentAll(this.state.selectedDocType) === 0 && this.getTabCnt() !== 0 ||
      this.countDocTypeWithSsqDataDocumentAll(this.state.selectedDocType) === 0))
      return this.renderNoDocumentPage();
  }

  renderDocumentTable() {
    return <>
      {this.state.selectedDocType !== DocType.TROUBLE_SHOOTING ?
        <BlogContainer aria-label={"Blog-page"}>
          <section className="community-body border-top-1">
            <div className={"wrapper container sub-container"}>
              <div className="community__content">
                <div className="content" style={{width: '100%'}}>
                  <ul className="community-item">
                    {/*문서 불러오는 부분*/}
                    {this.state.ssqDataDocuments.map((document) => {
                      return (<BlogDocumentListItem
                        commentList={this.props.commentList}
                        displayLoginPopup={this.props.displayLoginPopup}
                        key={document.id}
                        ssqDocument={document}
                        getTranslation={this.docListItemTrans}
                        languageService={this.props.languageService}
                        clickedTag={this.clickedTag}/>);
                    })}
                    {this.state.isMounted && this.selectDocTypeCountNoDocumentPage()}
                  </ul>
                </div>
              </div>
            </div>
          </section>
        </BlogContainer>
        : <>
          <ProductTablePadding>
            <SsqDataColumnTitles>
              <div className={"accordion-col-doc-num"}>{"No."}</div>
              <div className={"accordion-col-doc-title"}>{this.props.getTranslation("I18N_DOC_COL_NAME")}</div>
              <div className={"accordion-col-doc-bookmark"}>{this.props.getTranslation("I18N_DOC_COL_BOOKMARK")}</div>
              <div className={"accordion-col-doc-share"}>{this.props.getTranslation("I18N_DOC_COL_SHARE")}</div>
              <div className={"accordion-col-doc-language"}>{this.props.getTranslation("I18N_DOC_COL_LANG")}</div>
              <div className={"accordion-col-update-time"}>{this.props.getTranslation("I18N_DOC_COL_UPDATE_TIME")}</div>
              <div className={"accordion-col-click-count"}>{this.props.getTranslation("I18N_DOC_COL_VIEWS")}</div>
              <div className={"accordion-col-more"}></div>
            </SsqDataColumnTitles>
            <AccordionWrapper>
              <Accordion allowZeroExpanded>
                {this.state.ssqDataDocuments.map((document: ISsqDataDocument, index) => (
                  <div key={'' + index + ':' + document.id}>
                    <SsqDocumentsAccordionItem
                      postNum={index + 1}
                      document={document}
                      previousClickedDocumentId={this.state.previousClickedDocumentId}
                      setClickedDocumentIdFunc={this.setClickedDocumentIdFunc}
                      ssqDataRepository={this.props.ssqDataRepository}
                      languageService={this.props.languageService}
                      categoryStore={this.props.categoryStore}
                      loadAllCategories={this.props.loadAllCategories}
                      openToast={(type) => {
                        this.setState({toastType: type, seq: this.state.seq + 1});
                      }}
                    />
                  </div>
                ))}
              </Accordion>
            </AccordionWrapper>
          </ProductTablePadding>
          <ToastPopup languageService={this.props.languageService} loginInfo={this.props.loginInfo}
            seq={this.state.seq + 1}
            type={this.state.toastType}
          ></ToastPopup>
          {this.state.isMounted && this.selectDocTypeCountNoDocumentPage()}
        </>
      }
    </>;
  }


  setClickedDocumentIdFunc = (clickedDocumentId: number) => {
    this.setState({previousClickedDocumentId: clickedDocumentId});
  };

  getTabCnt() {
    let cnt = 0;
    if (this.state.ssqDataDocumentsCounts.technicalGuideCount > 0) cnt = cnt + 1;
    if (this.state.ssqDataDocumentsCounts.applicationNoteCount > 0) cnt = cnt + 1;
    if (this.state.ssqDataDocumentsCounts.troubleShootingCount > 0) cnt = cnt + 1;
    return cnt;
  };

  renderSubTabButton(docType: string) {
    const count = this.countDocTypeWithSsqDataDocumentAll(docType) || 0;

    if (this.state.isMounted && this.state.selectedDocType === docType && count != 0)
      return <div className={`tab-button selected`}
        onClick={() => {
          this.setState({
            selectedDocType: docType,
            pageNum: 0
          });
        }}>
        {this.props.getTranslation(getDocTypeLangKey(docType))} <span>{count}</span>
      </div>;

    return count > 0 &&
      <SwiperSlide className={`tab-button ${this.state.selectedDocType === docType ? "selected" : ""}`}
        onClick={() => {
          this.setState({
            selectedDocType: docType,
            pageNum: 0
          });
        }}>
        {this.props.getTranslation(getDocTypeLangKey(docType))} <span>{count}</span>
      </SwiperSlide>;
  }

  render() {
    SwiperCore.use([Navigation]);
    return (
      <div>
        {this.state.isMobile ? <SubTabButtons>
            <div className={"swiper-container"}>
              <Swiper
                slidesPerView={"auto"}
                navigation={{
                  prevEl: '.swiper-button-prev',
                  nextEl: '.swiper-button-next'
                }}
              >
                {this.renderSubTabButton(DocType.TECHNICAL_GUIDE)}
                {this.renderSubTabButton(DocType.APPLICATION_NOTE)}
                {this.renderSubTabButton(DocType.TROUBLE_SHOOTING)}
                <SwiperArrow>
                  <p className="swiper-button-prev"></p>
                  <p className="swiper-button-next"></p>
                </SwiperArrow>
              </Swiper>
            </div>
          </SubTabButtons>
          :
          <SubTabButtons>
            {this.renderSubTabButton(DocType.TECHNICAL_GUIDE)}
            {this.renderSubTabButton(DocType.APPLICATION_NOTE)}
            {this.renderSubTabButton(DocType.TROUBLE_SHOOTING)}
          </SubTabButtons>
        }
        {this.state.selectedDocType != this.NO_DATA
          &&
          <SubTabTableArea className={clsx(this.state.selectedDocType === DocType.TROUBLE_SHOOTING ? "" : "blog-more-btn")}>
            <TechnicalDocumentListArea>
              <div className={clsx(this.state.selectedDocType === DocType.TROUBLE_SHOOTING ? "" : "result-area blog-tab-area")}>
                {this.renderDocumentTable()}
                {this.isRenderTechnicalDocumentViewMore(this.state.selectedDocType) && <ViewmoreArea className="view-more-area">
                  <div className="view-more-list-box">
                    <div className={"ViewmoreBtn"}>
                      <button className={"view-more-button"} onClick={() => {
                        this.setState({pageNum: this.state.pageNum + 1});
                      }}>
                        {this.props.getTranslation("I18N_DOC_VIEW_MORE")}
                      </button>
                    </div>
                    <div className={"ViewmoreNum"}>
                      <span className={"page-count"}>{this.getPageCount()}</span>
                      <span>{this.getTotalCount()}</span>
                    </div>
                  </div>
                </ViewmoreArea>
                }
              </div>
            </TechnicalDocumentListArea>
          </SubTabTableArea>
        }
      </div>
    );
  }
}

export default connect(
  (state: any) => ({
    loginInfo: state.main.loginInfo,
  })
)(ProductTechnicalTabPanel);

